import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { authProvider } from './auth/authContext';
import { createQueryClient } from './lib/queryClient';
import './index.css';

async function bootstrap() {
  // Order matters, and the ordering is the whole reason this is not inline in
  // the component tree: authProvider.initialize() awaits Firebase restoring a
  // persisted session from IndexedDB, which is asynchronous even when the user
  // is signed in. Rendering before it resolves means the first component to
  // ask a question gets the wrong answer and bounces a signed-in user out.
  await authProvider.initialize();

  const container = document.getElementById('root');
  if (!container) throw new Error('#root is missing from index.html.');

  createRoot(container).render(
    <StrictMode>
      <App queryClient={createQueryClient()} />
    </StrictMode>,
  );
}

void bootstrap();
